import { render, staticRenderFns } from "./TwBookingDetailInner.vue?vue&type=template&id=1250f598&scoped=true&"
import script from "./TwBookingDetailInner.vue?vue&type=script&lang=js&"
export * from "./TwBookingDetailInner.vue?vue&type=script&lang=js&"
import style0 from "./TwBookingDetailInner.vue?vue&type=style&index=0&id=1250f598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1250f598",
  null
  
)

export default component.exports